import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Userlist from "../../components/UserListComponent/Userlist";
import { Box } from "@mui/material";
import Loader from "../Loader/Loader";
// import { ToastContainer } from "react-toastify";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#F2F2F2",
  ...theme.typography.body2,
  //   padding: `calc(1em + ${theme.spacing(1)})`,
  padding: theme.spacing("70px 0 0 250px"),
  borderRadius: 0,
  boxShadow: "none !important",
  fontSize: 20,
  fontWeight: "bold",
  color: "#004A99",
  height: "2000px",
}));

const UserList = () => {
  const [userList, setUserList] = useState([]);
  const [render, setRender] = useState(false);
  const [pending, setPending] = useState(true);

  const getUserList = async () => {
    console.log("api url", `api/v1/users/user`);
    const request = {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        withCredentials: true,
        // Authorization: token,
      },
    };
    setPending(true);
    fetch(`api/v1/users/user`, request)
      .then((response) => response.json())
      .then((res) => {
        console.log("user api res", res.users);
        setUserList(res.users);
        setPending(false);
      })
      .catch((err) => console.log("err", err));
  };

  useEffect(() => {
    getUserList();
  }, [render]);
  return (
    <>
      <Item>
        <Box sx={{ padding: "18px" }}>
          {!pending ? (
            <Userlist users={userList} setRender={setRender} render={render} />
          ) : (
            <Loader />
          )}
        </Box>
        {/* <ToastContainer /> */}
        {/* <Typography>User Lists</Typography> */}
      </Item>
    </>
  );
};

export default UserList;
